import React from 'react';
import { connect } from 'react-redux';
import { LoadingIcon } from '_components'
import styles from './OutstandingNotes.module.css'
import { TherapistDashboardOutstandingNotesRow } from './OutstandingNotesRow';


class TherapistDashboardOutstandingNotes extends React.Component {
    getDateString(date) {
        let options = { weekday: 'long', month: 'long', year: 'numeric', day: 'numeric' };
        let retval = date.toLocaleDateString("en-US", options);
        let daysDiff = Math.ceil(Math.abs(new Date(date) - new Date()) / (1000 * 60 * 60 * 24));
        daysDiff--;
        if (daysDiff === 0) {
            retval += ' (Today)';
        } else if ( daysDiff === 1 ) {
            retval += ' (Yesterday)';
        } else {
            retval += ' (' + daysDiff + ' days ago)';
        }
        return retval;
    }


    render() {
        if (this.props.loading === true) {
            return (
                <div className={styles.loading_div}>
                    <br />
                    <label>Loading...</label>
                    <br /><br />
                    <LoadingIcon size='large' />
                </div>
            );
        } else {
            return (
                <div>

                    <div className={styles.header_wrapper}>
                        <span className={styles.col}>Outstanding Notes</span>
                    </div>
                    <div className={styles.outstanding_notes_component}>

                        {Object.keys(this.props.dates)
                            .map(x => {
                                const date = this.props.dates[x];
                                return (
                                    <span key={date}>
                                        <div className={styles.col_date}>
                                            {this.getDateString(new Date(date))}
                                        </div>

                                        {Object.keys(this.props.notes)
                                            .filter(x => this.props.notes[x].DATE === date)
                                            .map(id => {
                                                const note = this.props.notes[id];
                                                return <TherapistDashboardOutstandingNotesRow key={note.ID} id={note.ID} />
                                            })
                                        }
                                    </span>
                                )
                            })
                        }






                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    let notes = Object.keys(state.entities.dashboard.outstandingNotes)
        .sort((a, b) => new Date(state.entities.dashboard.outstandingNotes[a].DATE).getTime() - new Date(state.entities.dashboard.outstandingNotes[b].DATE).getTime())
        .map(x => state.entities.dashboard.outstandingNotes[x]);

    let dates = Object.values(
        notes.reduce((acc, cur) => {
            if (!acc[cur.DATE]) acc[cur.DATE] = cur.DATE;
            return acc;
        }, {})
    );

    return {
        loading: state.ui.dashboard.loadingOutstandingNotes,
        notes,
        dates
    };
}

const connectedTherapistDashboardOutstandingNotes = connect(mapStateToProps)(TherapistDashboardOutstandingNotes);
export { connectedTherapistDashboardOutstandingNotes as TherapistDashboardOutstandingNotes };

